<template>
    <div>
        <page-title title="Homepage" icon="pe-7s-display2"></page-title>
    </div>
</template>

<script>
import PageTitle from "@/components/PageTitle.vue"

export default {
    name: "Homepage",
    components: {PageTitle},

    mounted() {
        let homePage = this.$store.state.user.homepage
            ? this.$store.state.user.homepage
            : "/dashboard";
        this.$router.push(homePage);
    }
}
</script>

<style scoped>

</style>
